import React, { Component } from 'react';

import CustMenuItem from './CustMenuItem';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";

class CustMenu extends Component {

    render() {
        const { location, miniNavbar } = this.props;
        const popoverContent = (
            <Menu>
                <MenuItem icon="log-out" text="Salir" onClick={ () => this.props.signout() } />
            </Menu>
        );
        const menuItems = [
            {
                label: 'inicio',
                url: '/',
                isMenu: false
            }, {
                label: 'ventas',
                isMenu: true,
                subItems: [{
                    label: 'resumen',
                    url: '/ventas/resumen'
                }, {
                    label: 'clientes',
                    url: '/ventas/clientes'
                }, {
                    label: 'escandallos',
                    url: '/ventas/escandallos'
                }, {
                    label: 'presupuestos',
                    url: '/ventas/presupuestos'
                }, {
                    label: 'pedidos',
                    url: '/ventas/pedidos'
                }, {
                    label: 'albaranes',
                    url: '/ventas/albaranes'
                }, {
                    label: 'facturas',
                    url: '/ventas/facturas'
                }, {
                    label: 'facturas proforma',
                    url: '/ventas/proforma'
                }]
            }, {
                label: 'compras',
                isMenu: true,
                subItems: [{
                    label: 'resumen',
                    url: '/compras/resumen'
                }, {
                    label: 'proveedores',
                    url: '/compras/proveedores'
                }, {
                    label: 'pedidos',
                    url: '/compras/pedidos'
                }, {
                    label: 'albaranes',
                    url: '/compras/albaranes'
                }, {
                    label: 'facturas',
                    url: '/compras/facturas'
                }]
            }, {
                label: 'proyectos',
                url: '/proyectos',
                isMenu: false
            }, {
                label: 'empleados',
                url: '/empleados',
                isMenu: false
            }, {
                label: 'configuración',
                isMenu: true,
                subItems: [{
                    label: 'productos',
                    url: '/productos'
                }, {
                    label: 'almacenes',
                    url: '/almacenes'
                }, {
                    label: 'usuarios',
                    url: '/usuarios'
                }, {
                    label: 'documentos',
                    url: '/documentos'
                }, {
                    label: 'alertas',
                    url: '/alertas'
                }]
            }
        ];

        return (
            <nav className="menu-container">
            {/*<nav className="navbar-default navbar-static-side" style={{ position: 'fixed' }} >*/}
                <div className="toggle-sidebar-left" >
                    <a
                        onClick={this.props.onChangeMiniNavbar}
                    >
                        <Icon icon={ miniNavbar ? 'chevron-right' : 'chevron-left' } iconSize={16} />
                    </a>
                </div>
                <ul className="nav">
                    <li className="menu-item-header">
                        <Popover
                            content={popoverContent}
                            interactionKind={PopoverInteractionKind.CLICK}
                            position={Position.BOTTOM_RIGHT}
                        >
                            <Icon
                                className="icon-custom"
                                title={false}
                                icon={'user'}
                                iconSize={30}
                                // color="#183650"
                            />
                        </Popover>
                        {/*<Icon icon="user" iconSize={30} />*/}
                        <span className="font-bold">
                            { `${this.props.user.get('name')} ${this.props.user.get('surname')}` }
                        </span>
                        <div className="logo-element">
                            Gestión CN Processed Steel
                        </div>
                    </li>
                    { menuItems.map( (item, i) => <CustMenuItem key={i} itemId={'item' + i} item={item} location={location} /> ) }
                </ul>
            </nav>
        );
    }

}

export default CustMenu;


// WEBPACK FOOTER //
// ./src/components/common/CustMenu.js